module.exports = __webpack_public_path__ + "static/media/logo.534695b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 108
// module chunks = 0